export const filterOutNullsy = (collection) => {
    return collection.filter((entry) => entry !== undefined && entry !== null);
};
